<template>
  <div class="page">
    <div class="page__content u-space u-space--large">
      <h1 class="h2">Ticket to Ride</h1>
      <p>
        This is a web app to help you play the physical game of Ticket to Ride
        whilst being remote from other players.
      </p>
      <p>
        Created during the COVID-19 pandemic by
        <a href="https://trysmudford.com">Trys Mudford</a>.
      </p>

      <p>
        <a href="/game" class="button">Start a new game</a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  components: {}
};
</script>
